/*
 * @Author: 孙培国
 * @Date: 2024-08-06 15:55:49
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-08-29 18:29:13
 * @FilePath: \vue2-vant2-rem-h5-template\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from './router.config.js'
import { corpId } from '@/config'
import { getDingTalkToken, getDingUserInfo } from '@/api/user'
const whiteList = [
  '/login',
  '/register',
  '/haveAccount',
  '/home',
  '/match',
  '/matchHome',
  '/bingPhone',
  '/matchDetails',
  '/register',
  '/train',
  '/registerList',
  '/unitregister',
  '/peopleRegistrationregiste'
]
const originalPush = Router.prototype.push
var dingdingStatus = true
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const createRouter = () =>
  new Router({
    mode: 'hash', // 如果你是 history模式 需要配置vue.config.js publicPath
    base: '/',
    // base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to, from, next) => {
  let isLogin = Boolean(localStorage.getItem('token'))
  console.log(localStorage.getItem('token'), to, isLogin)
  if (isLogin) {
    dingdingStatus = true
    next()
  } else {
    // 账号密码登录
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
